module.exports = __webpack_public_path__ + "static/img/hao.c6363c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hao.png
// module id = hU4I
// module chunks = 3